import React, { useCallback } from 'react'

import Translator from 'bazinga-translator'

import Button from '../Btn'
import GamesGrid from '../GamesGrid'
import { GridGame } from '../GamesGrid/types'
import useChangeCategory from '../GamesNavBar/hooks/useChangeCategory'
import { HeaderWrapper } from './styled/HeaderWrapper'
import { Label } from './styled/Label'
import { Wrapper } from './styled/Wrapper'

interface Props {
  games: GridGame[]
  categoryLabel: string
  slug: string
  rows: number
}

export function GamesCategoryGrid({ games, categoryLabel, slug, rows }: Props) {
  const { changeCategory } = useChangeCategory()

  const onClick = useCallback(() => changeCategory(slug), [changeCategory, slug])

  if (!games) {
    return null
  }

  return (
    <Wrapper>
      <HeaderWrapper>
        <Label onClick={onClick}>{categoryLabel}</Label>
        <Button
          onClick={onClick}
          link
          secondary
          sm
        >
          {Translator.trans('all', {}, 'messages')}
        </Button>
      </HeaderWrapper>
      <GamesGrid
        games={games}
        rows={rows}
      />
    </Wrapper>
  )
}
